import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";

let featureList = require('../Config/featureList.json');
let config = require('../Config/appConfig.json');
let DOWNLOAD_LINK_ANDROID = config.DOWNLOAD_LINK_ANDROID;
let DOWNLOAD_LINK_IOS = config.DOWNLOAD_LINK_IOS;
const context = "FeaturesSection.js";
var self = null;
@inject("appStore")
@observer
class FeaturesSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentWillMount = () => {
        self = this;
    }

    componentDidMount = () => {
        const script = document.createElement("script");

        script.src = "assets/slider/js/active.js";
        script.async = true;

        document.body.appendChild(script);
    }

    openDownloadLink = (where_to) => {
        var link_to_open = null;
        if (where_to === "android") {
            link_to_open = DOWNLOAD_LINK_ANDROID;
        } else if (where_to === "iOS") {
            link_to_open = DOWNLOAD_LINK_IOS;
        }

        if (link_to_open === null) {

        } else {
            var win = window.open(link_to_open, '_blank');

        }
    }

    render() {
        return (
            <div>

                <section className="pt-120 pb-120 section-pattern ov-hidden" id="about_us">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div class="about-apps-slider owl-carousel">

                                    <div class="app-single-slide">
                                        <img src="assets/custom_icons/screenshots/homeScreen.jpg" alt="" />
                                    </div>

                                    <div class="app-single-slide">
                                        <img src="assets/custom_icons/screenshots/absentNotification.png" alt="" />
                                    </div>

                                    <div class="app-single-slide">
                                        <img src="assets/custom_icons/screenshots/pickUp.png" alt="" />
                                    </div>

                                    <div class="app-single-slide">
                                        <img src="assets/custom_icons/screenshots/tracking.png" alt="" />
                                    </div>

                                    <div class="app-single-slide">
                                        <img src="assets/custom_icons/screenshots/absentMark.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 video-area mt-50 mt-lg-0">

                                <div className="section-title">
                                    <h3>About Hexa School</h3>
                                    <h2>Real time tracking application for your child's safety </h2>
                                    {/* <p></p> */}
                                </div>
                                <div className="about-nav-tab">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-items"> <a className="nav-link active" data-toggle="tab" href="#mission" role="tab"
                                            aria-selected="true">Hexa School</a> </li>
                                        {/* <li className="nav-items"> <a className="nav-link" data-toggle="tab" href="#vission" role="tab"
                                            aria-selected="false">Hexa School/a> </li> */}
                                    </ul>
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active" id="mission" role="tabpanel">
                                            <span>Real time GPS tracking.</span><br></br>
                                            <span>Pick up and drop alerts.</span><br></br>
                                            <span>Hexa for both the parents to track their child at the same time.</span><br></br>
                                            <span>Safety for your kid is guaranteed.</span><br></br><br></br><br></br>
                                            <div className="row align-items-center">
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="single-counter text-center text-blue">
                                                        <h2 className="count"><span>50 </span>k+</h2>
                                                        <p>Students Served</p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="single-counter text-center text-blue">
                                                        <h2 className="count"><span>50</span>+</h2>
                                                        <p>School Connected</p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className="single-counter text-center text-blue">
                                                        <h2 className="count"><span>100</span>k+</h2>
                                                        <p>Individual Pool Cars</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row align-items-center">
                                                <div className="col-lg-6 col-sm-6">
                                                    <a href="javascript:void(0)" className="btn-get-the-app hover-box-effect" onClick={(e) => this.openDownloadLink("android")}>
                                                        <img src="assets/img/custom_icons/playstore.png" className="svg" style={{ 'width': '30px', 'height': '30px', 'marginRight': '20px' }} alt="" /> Get In Android
                                                    </a>
                                                </div>
                                                {/* <div className="col-lg-6 col-sm-6">
                                                    <a href="javascript:void(0)" className="btn-get-the-app hover-box-effect" onClick={(e) => this.openDownloadLink("iOS")}>
                                                        <img src="assets/img/custom_icons/apple_icon.png" className="svg" style={{ 'width': '33px', 'height': '39px', 'marginRight': '20px' }} alt="" /> Get In iOS
                                                    </a>
                                                </div> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section class="pt-120 pb-120 section-pattern ov-hidden">
                    <div class="about-app-area" id="about">


                        <div class="about-us-bg-shape">
                            <img src="assets/slider/img/core-img/about-bg.png" alt="" />
                        </div>

                        <div class="container-fluid">
                            <div class="row align-items-center">

                                <div class="col-12 col-md-7">
                                    <div class="about-apps-slider owl-carousel">

                                        <div class="app-single-slide">
                                            <img src="assets/slider/img/bg-img/slide-1.jpg" alt="" />
                                        </div>

                                        <div class="app-single-slide">
                                            <img src="assets/slider/img/bg-img/slide-2.jpg" alt="" />
                                        </div>

                                        <div class="app-single-slide">
                                            <img src="assets/slider/img/bg-img/slide-3.jpg" alt="" />
                                        </div>

                                        <div class="app-single-slide">
                                            <img src="assets/slider/img/bg-img/slide-2.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-md-5">
                                    <div class="about-app-content">
                                        <h2>Hexa School</h2>
                                        <ul>An App with an array of features which help you in tracking.</ul>
                                        <ul>Once the child is picked up from home and dropped to school , you will be able to track the school bus.</ul>
                                        <ul>Track real time location of school bus.</ul>
                                        <ul>While at office , you need not be worried about the safety as it provides the cctv camera as one of the features of the app.</ul>
                                        <div class="app-feature-icon d-flex">

                                            <div class="single-app-feature-icon d-flex align-items-center justify-content-center">
                                                <img src="assets/slider/img/bg-img/icon-1.png" alt="" />
                                            </div>

                                            <div class="single-app-feature-icon d-flex align-items-center justify-content-center">
                                                <img src="assets/slider/img/bg-img/icon-2.png" alt="" />
                                            </div>

                                            <div class="single-app-feature-icon d-flex align-items-center justify-content-center">
                                                <img src="assets/slider/img/bg-img/icon-3.png" alt="" />
                                            </div>

                                            <div class="single-app-feature-icon d-flex align-items-center justify-content-center">
                                                <img src="assets/slider/img/bg-img/icon-4.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

            </div>
        );
    }
}

export default withRouter(FeaturesSection);


// WEBPACK FOOTER //
// ./src/Pages/FeaturesSection.js